import React from 'react';
import { createRoot } from 'react-dom/client';
// The announcement preview's Slack rendering; imported at the root because it styles
// components mounted on several pages.
import 'slack-blocks-to-jsx/dist/style.css';
import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error('missing #root');
createRoot(container).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
